import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@e2n/ui';

interface TerminAccordionProps {
  id: string;
  triggerLabel: string;
  children?: React.ReactNode;
  count?: number;
}

export function TerminAccordion({
  id,
  triggerLabel,
  children,
  count = 0,
}: TerminAccordionProps) {
  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value={id}>
        <AccordionTrigger className="flex items-center py-0">
          {count > 0 && <> {count}</>} {triggerLabel}
        </AccordionTrigger>
        <AccordionContent>
          <div className="max-h-48 overflow-y-auto">{children}</div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
